{
  "freezers": [
    {
      "id": "F-001",
      "label": "Hűtő A1",
      "temperature": -80,
      "location": "Labor 1 - Bal",
      "shelves": [
        {
          "id": "S-001",
          "label": "Polc 1",
          "position": 0,
          "boxes": [
            {
              "id": "B-001",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0001",
                  "type": "blood",
                  "donor": "D-001",
                  "date": "2025-11-15",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0002",
                  "type": "plasma",
                  "donor": "D-002",
                  "date": "2025-11-16",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0003",
                  "type": "serum",
                  "donor": "D-003",
                  "date": "2025-11-17",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0004",
                  "type": "dna",
                  "donor": "D-001",
                  "date": "2025-11-18",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0005",
                  "type": "blood",
                  "donor": "D-004",
                  "date": "2025-11-19",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0006",
                  "type": "tissue",
                  "donor": "D-005",
                  "date": "2025-11-20",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 0.3,
                  "unit": "g"
                },
                {
                  "id": "SPL-0007",
                  "type": "blood",
                  "donor": "D-006",
                  "date": "2025-12-01",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0008",
                  "type": "urine",
                  "donor": "D-007",
                  "date": "2025-12-02",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0009",
                  "type": "plasma",
                  "donor": "D-008",
                  "date": "2025-12-03",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-002",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0010",
                  "type": "serum",
                  "donor": "D-009",
                  "date": "2025-12-05",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0011",
                  "type": "dna",
                  "donor": "D-010",
                  "date": "2025-12-06",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0012",
                  "type": "blood",
                  "donor": "D-011",
                  "date": "2025-12-07",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0013",
                  "type": "plasma",
                  "donor": "D-001",
                  "date": "2025-12-08",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0014",
                  "type": "tissue",
                  "donor": "D-012",
                  "date": "2025-12-09",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0015",
                  "type": "blood",
                  "donor": "D-013",
                  "date": "2025-12-10",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0016",
                  "type": "urine",
                  "donor": "D-014",
                  "date": "2025-12-11",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0017",
                  "type": "serum",
                  "donor": "D-015",
                  "date": "2025-12-12",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0018",
                  "type": "dna",
                  "donor": "D-002",
                  "date": "2025-12-13",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-003",
              "label": "Doboz 3",
              "row": 0,
              "col": 2,
              "samples": [
                {
                  "id": "SPL-0019",
                  "type": "blood",
                  "donor": "D-016",
                  "date": "2026-01-05",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0020",
                  "type": "plasma",
                  "donor": "D-017",
                  "date": "2026-01-06",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0021",
                  "type": "serum",
                  "donor": "D-018",
                  "date": "2026-01-07",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0022",
                  "type": "tissue",
                  "donor": "D-019",
                  "date": "2026-01-08",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "g"
                },
                {
                  "id": "SPL-0023",
                  "type": "blood",
                  "donor": "D-020",
                  "date": "2026-01-09",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0024",
                  "type": "dna",
                  "donor": "D-003",
                  "date": "2026-01-10",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0025",
                  "type": "urine",
                  "donor": "D-021",
                  "date": "2026-01-11",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0026",
                  "type": "blood",
                  "donor": "D-022",
                  "date": "2026-01-12",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0027",
                  "type": "plasma",
                  "donor": "D-023",
                  "date": "2026-01-13",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-002",
          "label": "Polc 2",
          "position": 1,
          "boxes": [
            {
              "id": "B-004",
              "label": "Doboz 4",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0028",
                  "type": "serum",
                  "donor": "D-024",
                  "date": "2026-01-15",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0029",
                  "type": "blood",
                  "donor": "D-025",
                  "date": "2026-01-16",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0030",
                  "type": "dna",
                  "donor": "D-004",
                  "date": "2026-01-17",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0031",
                  "type": "plasma",
                  "donor": "D-026",
                  "date": "2026-01-18",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0032",
                  "type": "tissue",
                  "donor": "D-027",
                  "date": "2026-01-19",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.6,
                  "unit": "g"
                },
                {
                  "id": "SPL-0033",
                  "type": "blood",
                  "donor": "D-028",
                  "date": "2026-01-20",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0034",
                  "type": "urine",
                  "donor": "D-029",
                  "date": "2026-01-21",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0035",
                  "type": "serum",
                  "donor": "D-030",
                  "date": "2026-01-22",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0036",
                  "type": "blood",
                  "donor": "D-005",
                  "date": "2026-01-23",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-005",
              "label": "Doboz 5",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0037",
                  "type": "dna",
                  "donor": "D-031",
                  "date": "2026-02-01",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0038",
                  "type": "plasma",
                  "donor": "D-032",
                  "date": "2026-02-02",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0039",
                  "type": "blood",
                  "donor": "D-033",
                  "date": "2026-02-03",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0040",
                  "type": "tissue",
                  "donor": "D-034",
                  "date": "2026-02-04",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 0.3,
                  "unit": "g"
                },
                {
                  "id": "SPL-0041",
                  "type": "serum",
                  "donor": "D-035",
                  "date": "2026-02-05",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0042",
                  "type": "urine",
                  "donor": "D-036",
                  "date": "2026-02-06",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0043",
                  "type": "blood",
                  "donor": "D-006",
                  "date": "2026-02-07",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0044",
                  "type": "plasma",
                  "donor": "D-037",
                  "date": "2026-02-08",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0045",
                  "type": "dna",
                  "donor": "D-038",
                  "date": "2026-02-09",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-006",
              "label": "Doboz 6",
              "row": 0,
              "col": 2,
              "samples": [
                {
                  "id": "SPL-0046",
                  "type": "blood",
                  "donor": "D-039",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0047",
                  "type": "serum",
                  "donor": "D-040",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0048",
                  "type": "tissue",
                  "donor": "D-007",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0049",
                  "type": "plasma",
                  "donor": "D-041",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0050",
                  "type": "blood",
                  "donor": "D-042",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0051",
                  "type": "dna",
                  "donor": "D-043",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0052",
                  "type": "urine",
                  "donor": "D-044",
                  "date": "2026-02-16",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0053",
                  "type": "blood",
                  "donor": "D-008",
                  "date": "2026-02-17",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0054",
                  "type": "serum",
                  "donor": "D-045",
                  "date": "2026-02-18",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 1,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-003",
          "label": "Polc 3",
          "position": 2,
          "boxes": [
            {
              "id": "B-007",
              "label": "Doboz 7",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0055",
                  "type": "blood",
                  "donor": "D-046",
                  "date": "2026-02-20",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0056",
                  "type": "plasma",
                  "donor": "D-047",
                  "date": "2026-02-21",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0057",
                  "type": "dna",
                  "donor": "D-009",
                  "date": "2026-02-22",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-008",
              "label": "Doboz 8",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0058",
                  "type": "tissue",
                  "donor": "D-048",
                  "date": "2026-02-23",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "g"
                },
                {
                  "id": "SPL-0059",
                  "type": "blood",
                  "donor": "D-049",
                  "date": "2026-02-24",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0060",
                  "type": "urine",
                  "donor": "D-050",
                  "date": "2026-02-25",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-009",
              "label": "Doboz 9",
              "row": 0,
              "col": 2,
              "samples": [
                {
                  "id": "SPL-0061",
                  "type": "serum",
                  "donor": "D-010",
                  "date": "2026-02-26",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0062",
                  "type": "plasma",
                  "donor": "D-051",
                  "date": "2026-02-27",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0063",
                  "type": "blood",
                  "donor": "D-052",
                  "date": "2026-02-28",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-004",
          "label": "Polc 4",
          "position": 3,
          "boxes": [
            {
              "id": "B-010",
              "label": "Doboz 10",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0064",
                  "type": "dna",
                  "donor": "D-053",
                  "date": "2026-03-01",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0065",
                  "type": "blood",
                  "donor": "D-054",
                  "date": "2026-03-02",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0066",
                  "type": "tissue",
                  "donor": "D-011",
                  "date": "2026-03-03",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 0.3,
                  "unit": "g"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "F-002",
      "label": "Hűtő A2",
      "temperature": -80,
      "location": "Labor 1 - Jobb",
      "shelves": [
        {
          "id": "S-005",
          "label": "Polc 1",
          "position": 0,
          "boxes": [
            {
              "id": "B-011",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0067",
                  "type": "blood",
                  "donor": "D-055",
                  "date": "2025-10-01",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0068",
                  "type": "plasma",
                  "donor": "D-056",
                  "date": "2025-10-02",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0069",
                  "type": "serum",
                  "donor": "D-057",
                  "date": "2025-10-03",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0070",
                  "type": "dna",
                  "donor": "D-012",
                  "date": "2025-10-04",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0071",
                  "type": "blood",
                  "donor": "D-058",
                  "date": "2025-10-05",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0072",
                  "type": "tissue",
                  "donor": "D-059",
                  "date": "2025-10-06",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0073",
                  "type": "urine",
                  "donor": "D-060",
                  "date": "2025-10-07",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0074",
                  "type": "blood",
                  "donor": "D-013",
                  "date": "2025-10-08",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0075",
                  "type": "plasma",
                  "donor": "D-061",
                  "date": "2025-10-09",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-012",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0076",
                  "type": "serum",
                  "donor": "D-062",
                  "date": "2025-10-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0077",
                  "type": "dna",
                  "donor": "D-063",
                  "date": "2025-10-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0078",
                  "type": "blood",
                  "donor": "D-014",
                  "date": "2025-10-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0079",
                  "type": "tissue",
                  "donor": "D-064",
                  "date": "2025-10-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 0.3,
                  "unit": "g"
                },
                {
                  "id": "SPL-0080",
                  "type": "urine",
                  "donor": "D-065",
                  "date": "2025-10-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0081",
                  "type": "plasma",
                  "donor": "D-066",
                  "date": "2025-10-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-013",
              "label": "Doboz 3",
              "row": 0,
              "col": 2,
              "samples": [
                {
                  "id": "SPL-0082",
                  "type": "blood",
                  "donor": "D-067",
                  "date": "2025-11-01",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0083",
                  "type": "serum",
                  "donor": "D-015",
                  "date": "2025-11-02",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0084",
                  "type": "dna",
                  "donor": "D-068",
                  "date": "2025-11-03",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-006",
          "label": "Polc 2",
          "position": 1,
          "boxes": [
            {
              "id": "B-014",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0085",
                  "type": "blood",
                  "donor": "D-069",
                  "date": "2025-11-05",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0086",
                  "type": "plasma",
                  "donor": "D-070",
                  "date": "2025-11-06",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0087",
                  "type": "tissue",
                  "donor": "D-016",
                  "date": "2025-11-07",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 0.5,
                  "unit": "g"
                },
                {
                  "id": "SPL-0088",
                  "type": "urine",
                  "donor": "D-071",
                  "date": "2025-11-08",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0089",
                  "type": "serum",
                  "donor": "D-072",
                  "date": "2025-11-09",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0090",
                  "type": "blood",
                  "donor": "D-073",
                  "date": "2025-11-10",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-007",
          "label": "Polc 3",
          "position": 2,
          "boxes": [
            {
              "id": "B-015",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0091",
                  "type": "dna",
                  "donor": "D-074",
                  "date": "2025-12-01",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0092",
                  "type": "blood",
                  "donor": "D-017",
                  "date": "2025-12-02",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0093",
                  "type": "plasma",
                  "donor": "D-075",
                  "date": "2025-12-03",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-014",
          "label": "Polc 4",
          "position": 3,
          "boxes": [
            {
              "id": "B-025",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0139",
                  "type": "blood",
                  "donor": "D-239",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0140",
                  "type": "plasma",
                  "donor": "D-240",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0141",
                  "type": "serum",
                  "donor": "D-241",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0142",
                  "type": "dna",
                  "donor": "D-242",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0143",
                  "type": "tissue",
                  "donor": "D-243",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0144",
                  "type": "urine",
                  "donor": "D-244",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0145",
                  "type": "blood",
                  "donor": "D-245",
                  "date": "2026-02-16",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0146",
                  "type": "plasma",
                  "donor": "D-246",
                  "date": "2026-02-17",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0147",
                  "type": "serum",
                  "donor": "D-247",
                  "date": "2026-02-18",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-026",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0148",
                  "type": "blood",
                  "donor": "D-248",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0149",
                  "type": "plasma",
                  "donor": "D-249",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0150",
                  "type": "serum",
                  "donor": "D-250",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0151",
                  "type": "dna",
                  "donor": "D-251",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0152",
                  "type": "tissue",
                  "donor": "D-252",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0153",
                  "type": "urine",
                  "donor": "D-253",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "F-003",
      "label": "Hűtő B1",
      "temperature": -20,
      "location": "Labor 2 - Bal",
      "shelves": [
        {
          "id": "S-008",
          "label": "Polc 1",
          "position": 0,
          "boxes": [
            {
              "id": "B-016",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0094",
                  "type": "serum",
                  "donor": "D-076",
                  "date": "2026-01-05",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0095",
                  "type": "blood",
                  "donor": "D-077",
                  "date": "2026-01-06",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0096",
                  "type": "plasma",
                  "donor": "D-018",
                  "date": "2026-01-07",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0097",
                  "type": "urine",
                  "donor": "D-078",
                  "date": "2026-01-08",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0098",
                  "type": "tissue",
                  "donor": "D-079",
                  "date": "2026-01-09",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0099",
                  "type": "blood",
                  "donor": "D-080",
                  "date": "2026-01-10",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0100",
                  "type": "dna",
                  "donor": "D-019",
                  "date": "2026-01-11",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0101",
                  "type": "serum",
                  "donor": "D-081",
                  "date": "2026-01-12",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0102",
                  "type": "blood",
                  "donor": "D-082",
                  "date": "2026-01-13",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-017",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0103",
                  "type": "plasma",
                  "donor": "D-083",
                  "date": "2026-01-15",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0104",
                  "type": "blood",
                  "donor": "D-020",
                  "date": "2026-01-16",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0105",
                  "type": "tissue",
                  "donor": "D-084",
                  "date": "2026-01-17",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 0.3,
                  "unit": "g"
                }
              ]
            }
          ]
        },
        {
          "id": "S-009",
          "label": "Polc 2",
          "position": 1,
          "boxes": [
            {
              "id": "B-018",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0106",
                  "type": "blood",
                  "donor": "D-085",
                  "date": "2026-02-01",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0107",
                  "type": "dna",
                  "donor": "D-086",
                  "date": "2026-02-02",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0108",
                  "type": "serum",
                  "donor": "D-021",
                  "date": "2026-02-03",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0109",
                  "type": "urine",
                  "donor": "D-087",
                  "date": "2026-02-04",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0110",
                  "type": "plasma",
                  "donor": "D-088",
                  "date": "2026-02-05",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0111",
                  "type": "blood",
                  "donor": "D-089",
                  "date": "2026-02-06",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-015",
          "label": "Polc 3",
          "position": 2,
          "boxes": [
            {
              "id": "B-027",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0154",
                  "type": "blood",
                  "donor": "D-254",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0155",
                  "type": "plasma",
                  "donor": "D-255",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0156",
                  "type": "serum",
                  "donor": "D-256",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0157",
                  "type": "dna",
                  "donor": "D-257",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0158",
                  "type": "tissue",
                  "donor": "D-258",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0159",
                  "type": "urine",
                  "donor": "D-259",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0160",
                  "type": "blood",
                  "donor": "D-260",
                  "date": "2026-02-16",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0161",
                  "type": "plasma",
                  "donor": "D-261",
                  "date": "2026-02-17",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0162",
                  "type": "serum",
                  "donor": "D-262",
                  "date": "2026-02-18",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-028",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0163",
                  "type": "blood",
                  "donor": "D-263",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0164",
                  "type": "plasma",
                  "donor": "D-264",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0165",
                  "type": "serum",
                  "donor": "D-265",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0166",
                  "type": "dna",
                  "donor": "D-266",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0167",
                  "type": "tissue",
                  "donor": "D-267",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0168",
                  "type": "urine",
                  "donor": "D-268",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-016",
          "label": "Polc 4",
          "position": 3,
          "boxes": [
            {
              "id": "B-029",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0169",
                  "type": "blood",
                  "donor": "D-269",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0170",
                  "type": "plasma",
                  "donor": "D-270",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0171",
                  "type": "serum",
                  "donor": "D-271",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0172",
                  "type": "dna",
                  "donor": "D-272",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0173",
                  "type": "tissue",
                  "donor": "D-273",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0174",
                  "type": "urine",
                  "donor": "D-274",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0175",
                  "type": "blood",
                  "donor": "D-275",
                  "date": "2026-02-16",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0176",
                  "type": "plasma",
                  "donor": "D-276",
                  "date": "2026-02-17",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0177",
                  "type": "serum",
                  "donor": "D-277",
                  "date": "2026-02-18",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-030",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0178",
                  "type": "blood",
                  "donor": "D-278",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0179",
                  "type": "plasma",
                  "donor": "D-279",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0180",
                  "type": "serum",
                  "donor": "D-280",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0181",
                  "type": "dna",
                  "donor": "D-281",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0182",
                  "type": "tissue",
                  "donor": "D-282",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0183",
                  "type": "urine",
                  "donor": "D-283",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "F-004",
      "label": "Hűtő B2",
      "temperature": -20,
      "location": "Labor 2 - Jobb",
      "shelves": [
        {
          "id": "S-010",
          "label": "Polc 1",
          "position": 0,
          "boxes": [
            {
              "id": "B-019",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0112",
                  "type": "tissue",
                  "donor": "D-090",
                  "date": "2025-09-01",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "g"
                },
                {
                  "id": "SPL-0113",
                  "type": "blood",
                  "donor": "D-091",
                  "date": "2025-09-02",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0114",
                  "type": "plasma",
                  "donor": "D-022",
                  "date": "2025-09-03",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0115",
                  "type": "dna",
                  "donor": "D-092",
                  "date": "2025-09-04",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0116",
                  "type": "serum",
                  "donor": "D-093",
                  "date": "2025-09-05",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0117",
                  "type": "blood",
                  "donor": "D-094",
                  "date": "2025-09-06",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0118",
                  "type": "urine",
                  "donor": "D-023",
                  "date": "2025-09-07",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0119",
                  "type": "blood",
                  "donor": "D-095",
                  "date": "2025-09-08",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0120",
                  "type": "plasma",
                  "donor": "D-096",
                  "date": "2025-09-09",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-020",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0121",
                  "type": "dna",
                  "donor": "D-097",
                  "date": "2025-09-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0122",
                  "type": "blood",
                  "donor": "D-024",
                  "date": "2025-09-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0123",
                  "type": "serum",
                  "donor": "D-098",
                  "date": "2025-09-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-011",
          "label": "Polc 2",
          "position": 1,
          "boxes": [
            {
              "id": "B-021",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0124",
                  "type": "blood",
                  "donor": "D-099",
                  "date": "2026-01-20",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0125",
                  "type": "tissue",
                  "donor": "D-025",
                  "date": "2026-01-21",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0126",
                  "type": "plasma",
                  "donor": "D-100",
                  "date": "2026-01-22",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-017",
          "label": "Polc 3",
          "position": 2,
          "boxes": [
            {
              "id": "B-031",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0184",
                  "type": "blood",
                  "donor": "D-284",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0185",
                  "type": "plasma",
                  "donor": "D-285",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0186",
                  "type": "serum",
                  "donor": "D-286",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0187",
                  "type": "dna",
                  "donor": "D-287",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0188",
                  "type": "tissue",
                  "donor": "D-288",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0189",
                  "type": "urine",
                  "donor": "D-289",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0190",
                  "type": "blood",
                  "donor": "D-290",
                  "date": "2026-02-16",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0191",
                  "type": "plasma",
                  "donor": "D-291",
                  "date": "2026-02-17",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0192",
                  "type": "serum",
                  "donor": "D-292",
                  "date": "2026-02-18",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-032",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0193",
                  "type": "blood",
                  "donor": "D-293",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0194",
                  "type": "plasma",
                  "donor": "D-294",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0195",
                  "type": "serum",
                  "donor": "D-295",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0196",
                  "type": "dna",
                  "donor": "D-296",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0197",
                  "type": "tissue",
                  "donor": "D-297",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0198",
                  "type": "urine",
                  "donor": "D-298",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-018",
          "label": "Polc 4",
          "position": 3,
          "boxes": [
            {
              "id": "B-033",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0199",
                  "type": "blood",
                  "donor": "D-299",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0200",
                  "type": "plasma",
                  "donor": "D-300",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0201",
                  "type": "serum",
                  "donor": "D-301",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0202",
                  "type": "dna",
                  "donor": "D-302",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0203",
                  "type": "tissue",
                  "donor": "D-303",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0204",
                  "type": "urine",
                  "donor": "D-304",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0205",
                  "type": "blood",
                  "donor": "D-305",
                  "date": "2026-02-16",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0206",
                  "type": "plasma",
                  "donor": "D-306",
                  "date": "2026-02-17",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0207",
                  "type": "serum",
                  "donor": "D-307",
                  "date": "2026-02-18",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-034",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0208",
                  "type": "blood",
                  "donor": "D-308",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0209",
                  "type": "plasma",
                  "donor": "D-309",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0210",
                  "type": "serum",
                  "donor": "D-310",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0211",
                  "type": "dna",
                  "donor": "D-311",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0212",
                  "type": "tissue",
                  "donor": "D-312",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0213",
                  "type": "urine",
                  "donor": "D-313",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "F-005",
      "label": "Hűtő C1",
      "temperature": 4,
      "location": "Labor 3",
      "shelves": [
        {
          "id": "S-012",
          "label": "Polc 1",
          "position": 0,
          "boxes": [
            {
              "id": "B-022",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0127",
                  "type": "blood",
                  "donor": "D-001",
                  "date": "2026-03-01",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0128",
                  "type": "serum",
                  "donor": "D-002",
                  "date": "2026-03-01",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0129",
                  "type": "plasma",
                  "donor": "D-003",
                  "date": "2026-03-02",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0130",
                  "type": "urine",
                  "donor": "D-004",
                  "date": "2026-03-02",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0131",
                  "type": "blood",
                  "donor": "D-005",
                  "date": "2026-03-03",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0132",
                  "type": "dna",
                  "donor": "D-006",
                  "date": "2026-03-03",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-023",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0133",
                  "type": "tissue",
                  "donor": "D-007",
                  "date": "2026-03-03",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 0.3,
                  "unit": "g"
                },
                {
                  "id": "SPL-0134",
                  "type": "blood",
                  "donor": "D-008",
                  "date": "2026-03-04",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0135",
                  "type": "plasma",
                  "donor": "D-009",
                  "date": "2026-03-04",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 2,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-013",
          "label": "Polc 2",
          "position": 1,
          "boxes": [
            {
              "id": "B-024",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0136",
                  "type": "serum",
                  "donor": "D-010",
                  "date": "2026-03-04",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0137",
                  "type": "blood",
                  "donor": "D-011",
                  "date": "2026-03-04",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0138",
                  "type": "dna",
                  "donor": "D-012",
                  "date": "2026-03-04",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 0.5,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-019",
          "label": "Polc 3",
          "position": 2,
          "boxes": [
            {
              "id": "B-035",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0214",
                  "type": "blood",
                  "donor": "D-314",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0215",
                  "type": "plasma",
                  "donor": "D-315",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0216",
                  "type": "serum",
                  "donor": "D-316",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0217",
                  "type": "dna",
                  "donor": "D-317",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0218",
                  "type": "tissue",
                  "donor": "D-318",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0219",
                  "type": "urine",
                  "donor": "D-319",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0220",
                  "type": "blood",
                  "donor": "D-320",
                  "date": "2026-02-16",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0221",
                  "type": "plasma",
                  "donor": "D-321",
                  "date": "2026-02-17",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0222",
                  "type": "serum",
                  "donor": "D-322",
                  "date": "2026-02-18",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-036",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0223",
                  "type": "blood",
                  "donor": "D-323",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0224",
                  "type": "plasma",
                  "donor": "D-324",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0225",
                  "type": "serum",
                  "donor": "D-325",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0226",
                  "type": "dna",
                  "donor": "D-326",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0227",
                  "type": "tissue",
                  "donor": "D-327",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0228",
                  "type": "urine",
                  "donor": "D-328",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                }
              ]
            }
          ]
        },
        {
          "id": "S-020",
          "label": "Polc 4",
          "position": 3,
          "boxes": [
            {
              "id": "B-037",
              "label": "Doboz 1",
              "row": 0,
              "col": 0,
              "samples": [
                {
                  "id": "SPL-0229",
                  "type": "blood",
                  "donor": "D-329",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0230",
                  "type": "plasma",
                  "donor": "D-330",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0231",
                  "type": "serum",
                  "donor": "D-331",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0232",
                  "type": "dna",
                  "donor": "D-332",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0233",
                  "type": "tissue",
                  "donor": "D-333",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0234",
                  "type": "urine",
                  "donor": "D-334",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0235",
                  "type": "blood",
                  "donor": "D-335",
                  "date": "2026-02-16",
                  "position": [
                    2,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0236",
                  "type": "plasma",
                  "donor": "D-336",
                  "date": "2026-02-17",
                  "position": [
                    2,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0237",
                  "type": "serum",
                  "donor": "D-337",
                  "date": "2026-02-18",
                  "position": [
                    2,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                }
              ]
            },
            {
              "id": "B-038",
              "label": "Doboz 2",
              "row": 0,
              "col": 1,
              "samples": [
                {
                  "id": "SPL-0238",
                  "type": "blood",
                  "donor": "D-338",
                  "date": "2026-02-10",
                  "position": [
                    0,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0239",
                  "type": "plasma",
                  "donor": "D-339",
                  "date": "2026-02-11",
                  "position": [
                    0,
                    1
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0240",
                  "type": "serum",
                  "donor": "D-340",
                  "date": "2026-02-12",
                  "position": [
                    0,
                    2
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0241",
                  "type": "dna",
                  "donor": "D-341",
                  "date": "2026-02-13",
                  "position": [
                    1,
                    0
                  ],
                  "volume": 1.5,
                  "unit": "ml"
                },
                {
                  "id": "SPL-0242",
                  "type": "tissue",
                  "donor": "D-342",
                  "date": "2026-02-14",
                  "position": [
                    1,
                    1
                  ],
                  "volume": 0.4,
                  "unit": "g"
                },
                {
                  "id": "SPL-0243",
                  "type": "urine",
                  "donor": "D-343",
                  "date": "2026-02-15",
                  "position": [
                    1,
                    2
                  ],
                  "volume": 3,
                  "unit": "ml"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "sampleTypes": {
    "blood": {
      "label": "Vér",
      "color": "#dc2626"
    },
    "plasma": {
      "label": "Plazma",
      "color": "#f59e0b"
    },
    "serum": {
      "label": "Szérum",
      "color": "#10b981"
    },
    "dna": {
      "label": "DNS",
      "color": "#8b5cf6"
    },
    "tissue": {
      "label": "Szövet",
      "color": "#ec4899"
    },
    "urine": {
      "label": "Vizelet",
      "color": "#06b6d4"
    }
  }
}